/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section1_TitleInputs */

const en_privacy_section1_title = /** @type {(inputs: Privacy_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Commitment to Privacy`)
};

const ko_privacy_section1_title = /** @type {(inputs: Privacy_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 보호 약속`)
};

const ja_privacy_section1_title = /** @type {(inputs: Privacy_Section1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーへの取り組み`)
};

/**
* | output |
* | --- |
* | "Our Commitment to Privacy" |
*
* @param {Privacy_Section1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section1_title = /** @type {((inputs?: Privacy_Section1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section1_title(inputs)
	if (locale === "ko") return ko_privacy_section1_title(inputs)
	return ja_privacy_section1_title(inputs)
});